import Vue from "vue";
import axios from "axios";
import router from "@/router";
import relatoriosStore from "./relatorios";
import moment from "moment";

const getDefaultState = () => {
  return {
    cargas: {
      carregando: false,
      dados: null,
    },
    veiculo: {
      carregando: false,
      msgErro: "",
      dados: null,
    },
    pedidosLiberados: {
      carregando: false,
      msgErro: "",
      dados: [],
    },
    caixaSelec: 0,
    itemSelecionado: null,
    id_carga: 0,
    qtde_carregar: "",
    configuracoes: {
      carregando: true,
      dados: null,
    },
    listaPlacas: {
      carregando: true,
      dados: [],
    },
    alterouPlaca: false,
    cargaSelec: null,
    ver_detalhes: false,
    selecionarCarga: false,
    config_horarios: {
      carregando: true,
      salvando: false,
      editou_prox_dia: false,
      hora_base: {
        dias_semana: [],
        hora_lim: "",
        hora_prox_carreg: "",
      },
      retorno: {
        msg: "",
        erro: false
      },
      dados: null,
    },
  };
};

const formacaoCargaStore = {
  namespaced: true,
  state: {
    ...getDefaultState(),
    filtros: {
      id: 0,
      codvendedor: "",
      dtini: moment().format("YYYY-MM-DD"),
      dtfim: moment().add(2, "days").format("YYYY-MM-DD"),
      status: [],
      statusFiltrar: "",
    },
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setAltPlaca(state, value) {
      state.alterouPlaca = value
    },
    setVeiculo(state, value) {
      state.veiculo.dados = value;
    },
    setPedidosLiberados(state, value) {
      state.pedidosLiberados.dados = value;
    },
    setCaixa(state, value) {
      state.caixaSelec = parseInt(value);
    },
    setIdCarga(state, value) {
      state.id_carga = value;
    },
    setQtdeCarregar(state, value) {
      state.qtde_carregar = value;
    },
    setPlacas(state, value) {
      state.listaPlacas.dados = value;
    },
    setCarga(state, value) {
      state.cargaSelec = value;
    },
    setVerDetalhes(state, value) {
      state.ver_detalhes = value;
    },
    setSelecionarCarga(state, value) {
      state.selecionarCarga = value;
    },
    setCfgHorarios(state, value) {
      state.config_horarios.dados = value;
    },
  },
  actions: {
    async buscarVeiculo(context) {
      context.commit("setVeiculo", null);
      context.state.veiculo.carregando = true;
      context.state.veiculo.msgErro = "";
      try {
        await axios
          .get("/nutricao-animal/formacao-carga/veiculo", {
            params: {
              placa: context.state.cargaSelec.placa,
            },
          })
          .then((res) => {
            if (res.data.success) {
              context.commit("setVeiculo", res.data.data);
            } else {
              context.state.veiculo.msgErro = res.data.msg;
            }
          });
      } catch (error) {
        context.state.veiculo.msgErro = error;
      } finally {
        context.state.veiculo.carregando = false;
      }
    },
    async buscarPedidosLiberados(context) {
      context.commit("setPedidosLiberados", []);

      context.state.pedidosLiberados.msgErro = "";
      context.state.pedidosLiberados.carregando = true;

      if (
        !context.state.cargaSelec.inf_pedido ||
        context.state.caixaSelec == 0
      ) {
        try {
          await axios
            .get("/nutricao-animal/formacao-carga/pedidos", {
              params: {
                placa: context.state.cargaSelec.placa,
                cx: context.state.caixaSelec,
                id_carga: context.state.id_carga,
                cod_vendedor:
                  parseInt(context.state.cargaSelec.cod_vendedor) ?? 0,
              },
            })
            .then((res) => {
              if (res.data.success) {
                context.commit("setPedidosLiberados", res.data.data);
                for (const ped of context.state.pedidosLiberados.dados) {
                  context.state.itemSelecionado = ped;
                  ped.saldo = context.getters.saldoProduto;
                }
              } else {
                context.state.pedidosLiberados.msgErro = res.data.msg;
              }
            })
            .catch((error) => {
              context.state.pedidosLiberados.msgErro = error;
            });
        } catch (error) {
          context.state.pedidosLiberados.msgErro = error;
        } finally {
          context.state.pedidosLiberados.carregando = false;
        }
      }
      if (context.state.caixaSelec > 0) {
        var itensSelecCx = [];
        var dados = [];
        if (context.state.cargaSelec.inf_pedido) {
          context.state.cargaSelec.dist_caixas
            .filter((dc) => dc.caixa == 0)
            .forEach((i) => dados.push(i));
        } else {
          context.state.pedidosLiberados.dados.filter((p) =>
            dados.push({ pedido: p })
          );
        }
        dados.forEach((i) => {
          for (const item of i.pedido.itens) {
            item.nr_pedido = i.pedido.nr_pedido;
            item.cidade_entrega = i.pedido.cidade_entrega;
            item.nome_cliente = i.pedido.nome_cliente;
            item.capac_cx = 0;
            item.saldo = 0;
            item.emissao = i.pedido.emissao;
            item.filial = i.pedido.filial;
            item.filial_destino = i.pedido.filial_destino;
            item.pessoa = i.pedido.pessoa;
            item.cod_pedido = i.pedido.cod_pedido;
            item.desc_vendedor = i.pedido.desc_vendedor;
            context.state.itemSelecionado = item;
            item.saldo = context.getters.saldoProduto;
            item.pesquisa = i.pedido.pesquisa.concat(item.produto);

            if (context.state.veiculo.dados) {
              if (
                context.state.veiculo.dados.caixas
                  .find((cx) => cx.caixa == context.state.caixaSelec)
                  .capacidade.findIndex(
                    (cap) =>
                      cap.gp == item.gp &&
                      cap.sgp == item.sgp &&
                      cap.item == item.item
                  ) >= 0
              ) {
                item.capac_cx = context.state.veiculo.dados.caixas
                  .find((cx) => cx.caixa == context.state.caixaSelec)
                  .capacidade.find(
                    (cap) =>
                      cap.gp == item.gp &&
                      cap.sgp == item.sgp &&
                      cap.item == item.item
                  ).capacidade;
              }
            }

            itensSelecCx.push(item);
          }
        });
        context.commit("setPedidosLiberados", itensSelecCx);
        context.state.pedidosLiberados.carregando = false;
      }
    },
    selecionarProdutoCaixa(context, value) {
      //context.state.veiculo.dados.caixas.find((cx) => cx.caixa == context.state.caixaSelec).capacidade.find((cap) => cap.)
      context.state.cargaSelec.dist_caixas.push({
        caixa: context.state.caixaSelec,
        pedido: value,
        qtde: parseInt(context.state.qtde_carregar),
      });
    },
    async salvarFormacaoCarga(context) {
      await axios
        .post(
          "/nutricao-animal/formacao-carga/cargas",
          context.state.cargaSelec,
          {
            params: {
              id: context.state.id_carga ?? 0,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            Vue.toasted.success(res.data.msg);
            router.replace("/formacao-carga");
          } else {
            Vue.toasted.error(res.data.msg);
            return false;
          }
        })
        .catch((error) => {
          Vue.toasted.error(error);
          return false;
        });
    },
    async buscarCargas(context) {
      context.state.cargas.carregando = true;
      if (!context.state.selecionarCarga) context.state.cargas.dados = null;
      context.state.filtros.id = context.state.id_carga;
      context.state.filtros.codvendedor =
        relatoriosStore.state.vendedorSelecionado ?? "";

      context.state.filtros.statusFiltrar =
        context.state.filtros.status.toString();

      const filtroNovo = { ...context.state.filtros };
      delete filtroNovo.status;

      await axios
        .get("/nutricao-animal/formacao-carga/cargas", {
          params: filtroNovo,
        })
        .then((res) => {
          if (res.data.success) {
            if (context.state.selecionarCarga) {
              context.state.cargaSelec = res.data.data.cargas[0];
              if (
                context.state.cargas.dados &&
                context.state.cargas.dados.cargas.length > 0
              ) {
                var pos = context.state.cargas.dados.cargas.findIndex(
                  (c) => c.id == context.state.cargaSelec.id
                );
                context.state.cargas.dados.cargas[pos] =
                  context.state.cargaSelec;
              }
            } else {
              context.state.cargas.dados = res.data.data;
            }
          } else {
            Vue.toasted.error(res.data.msg);
          }
        })
        .catch((error) => Vue.toasted.error(error))
        .finally(() => {
          context.state.cargas.carregando = false;
        });
    },
    async buscarConfiguracoes(context) {
      context.state.configuracoes.carregando = true;
      context.state.configuracoes.dados = null;
      await axios
        .get("/nutricao-animal/formacao-carga/configuracoes")
        .then((res) => {
          if (res.data.success) {
            context.state.configuracoes.dados = res.data.data;
          } else Vue.toasted.error(res.data.msg);
        })
        .catch((e) => Vue.toasted.error(e))
        .finally(() => {
          context.state.configuracoes.carregando = false;
        });
    },
    async buscarTodasPlacas(context) {
      context.state.listaPlacas.carregando = true;
      context.commit("setPlacas", []);
      if (
        sessionStorage.getItem("nutricao-animal-placas") != undefined &&
        sessionStorage.getItem("nutricao-animal-placas") != ""
      ) {
        context.commit(
          "setPlacas",
          JSON.parse(sessionStorage.getItem("nutricao-animal-placas"))
        );
        context.state.listaPlacas.carregando = false;
      } else {
        await axios
          .get("/nutricao-animal/formacao-carga/veiculo", {
            params: {
              funcao: "TODAS-AS-PLACAS",
            },
          })
          .then((res) => {
            if (res.data.success) {
              context.commit("setPlacas", res.data.data);
              sessionStorage.setItem(
                "nutricao-animal-placas",
                JSON.stringify(context.state.listaPlacas.dados)
              );
            }
          })
          .finally(() => (context.state.listaPlacas.carregando = false));
      }
    },
    async buscarHorarios(context) {
      context.commit("setCfgHorarios", null);
      context.state.config_horarios.carregando = true;
      await axios
        .get("/nutricao-animal/formacao-carga/config-horarios")
        .then((res) => {
          if (res.data.success) {
            context.commit("setCfgHorarios", res.data.data);
          } else {
            Vue.toasted.error(res.data.msg);
          }
        })
        .catch((e) => Vue.toasted.error(e))
        .finally(() => (context.state.config_horarios.carregando = false));
    },
    async salvarHorarios(context) {
      context.state.config_horarios.salvando = true;
      context.state.config_horarios.retorno.msg = ""
      context.state.config_horarios.retorno.erro = false
      var res = await axios.post(
        "/nutricao-animal/formacao-carga/config-horarios",
        context.state.config_horarios
      );
      context.state.config_horarios.salvando = false;

      if (res.data.success) {
        return true;
      } else {
        context.state.config_horarios.retorno.msg = res.data.msg
        context.state.config_horarios.retorno.erro = true
        return false;
      }
    },
  },
  getters: {
    saldoProduto(state) {
      var qtdeUsada = 0;
      if (state.cargaSelec.dist_caixas.length > 0) {
        if (state.caixaSelec > 0) {
          state.cargaSelec.dist_caixas
            .filter(
              (dc) =>
                dc.caixa > 0 &&
                dc.pedido.filial_destino ==
                state.itemSelecionado.filial_destino &&
                dc.pedido.filial == state.itemSelecionado.filial &&
                dc.pedido.pessoa == state.itemSelecionado.pessoa &&
                dc.pedido.nr_pedido == state.itemSelecionado.nr_pedido &&
                dc.pedido.gp == state.itemSelecionado.gp &&
                dc.pedido.sgp == state.itemSelecionado.sgp &&
                dc.pedido.item == state.itemSelecionado.item
            )
            .forEach((cx) => (qtdeUsada += cx.qtde));
          /*state.cargaSelec.dist_caixas
            .filter(
              (dc) =>
                dc.caixa > 0 && 
                dc.pedido.cod_pedido_item ==
                state.itemSelecionado.cod_pedido_item
            )
            .forEach((cx) => (qtdeUsada += cx.qtde));*/
        } else {
          state.cargaSelec.dist_caixas
            .filter(
              (dc) =>
                dc.caixa == 0 &&
                dc.pedido.cod_pedido == state.itemSelecionado.cod_pedido
            )
            .forEach((cx) => (qtdeUsada += cx.qtde));
        }
      }
      return state.itemSelecionado.qtde_usar - qtdeUsada;
    },
    totalCarregado(state) {
      var totCarreg = 0;
      if (state.cargaSelec.placa != "") {
        state.cargaSelec.dist_caixas.forEach(
          (dc) => dc.caixa > 0 && (totCarreg += dc.qtde)
        );
      } else {
        state.cargaSelec.dist_caixas.forEach(
          (dc) => dc.caixa == 0 && (totCarreg += dc.qtde)
        );
      }

      return totCarreg;
    },
  },
};

export default formacaoCargaStore;
